class CustomSelect extends HTMLElement {
    constructor() {
        super();
        this.panel = this.querySelector('.custom-options__list-wrapper');
        this.button = this.querySelector('button');
        this.field = this.querySelector('input.custom-field');
        this.parent = this.querySelector('div.select');
        this.elements = {
            input: this.querySelector('input[type="radio"]'),
            button: this.querySelector('button'),
            panel: this.querySelector('.custom-options__list-wrapper'),
            field: this.querySelector('input.custom-field')
        };
        this.querySelectorAll('button').forEach(button => button.addEventListener('mouseout', this.closePanel.bind(this)));
        this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.openPanel.bind(this)));
        this.querySelectorAll('input[type="radio"]').forEach(input => input.addEventListener('click', this.onItemSelect.bind(this)));
        this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
        this.setDefaults();
    }

    setDefaults() {
       this.querySelectorAll('input[type="radio"]').forEach(input => {
         if(input.checked) {
           this.button.classList.add("selected");
           this.field.value = input.value;
         }
       })
    }

    onInvalid(event) {
        console.log(event.currentTarget)
        this.elements.button.focus();
        this.elements.button.classList.add("error")
    }


    hidePanel() {
        this.elements.button.setAttribute('aria-expanded', 'false');
        this.elements.panel.classList.contains('visually-hidden') ? false : this.elements.panel.classList.add('visually-hidden');
    }

    onFocusOut(event) {
       
    }

    openPanel() {
        const siblings = this.parentNode.querySelectorAll('custom-select');
        siblings.forEach(sibling => {
            if (sibling !== this) {
                sibling.hidePanel();
            }
        })
        this.elements.button.focus();
        this.elements.panel.classList.contains('visually-hidden') ? this.elements.panel.classList.remove('visually-hidden') : false;
        this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closePanel(event) {
        console.log(event.relatedTarget.nodeName)
        const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.target.nodeName === null || shouldClose) {
        this.hidePanel();
      }
    }
    onContainerKeyUp(event) {
        if (event.code.toUpperCase() !== 'ESCAPE') return;

        this.hidePanel();
        this.elements.button.focus();
        
    }
    onItemSelect(event) {
        const selectedVal = event.currentTarget.value;
        console.log(event.currentTarget.checked)
        console.log(selectedVal)
        this.field.value = selectedVal;
        this.field.classList.add("selected");
        // this.parent.classList.add("selected");
        this.elements.button.classList.add("selected");
        this.hidePanel()
    }

}

customElements.define('custom-select', CustomSelect)